import(/* webpackMode: "eager" */ "/Volumes/External/Documents/StyleNow-AI/stylenow-mobile-web-2/app/page.tsx");
